import { Button, ButtonColor, Pill, Text } from '@oy/uidesktop';
import { SystemIcon } from '@oy/uiicon';
import { useTranslate } from 'src/hooks';
import styles from './DocumentCard.module.css';

type DocumentCardProps = {
  needToSign: boolean;
  title: string;
  documentId: string;
  onClickReadDocument: (documentId: string) => void;
};

export const DocumentCard = ({
  needToSign,
  title,
  documentId,
  onClickReadDocument,
}: DocumentCardProps) => {
  const { getTranslation } = useTranslate();
  return (
    <div className={styles.cardContainer}>
      <div className={styles.titleSignDocument}>
        {needToSign ? (
          <SystemIcon name="document" />
        ) : (
          <div className={styles.pill}>
            <Pill color={Pill.Color.Green}>
              {getTranslation('common_signed')}
            </Pill>
          </div>
        )}
        <Text textStyle={Text.Style.BodyLgRegular}>{title}</Text>
        {needToSign ? (
          <Button
            className={styles.marginLeftAuto}
            size={Button.Size.Small}
            onClick={() => onClickReadDocument(documentId)}
          >
            {getTranslation('common_review')}
          </Button>
        ) : (
          <Button
            className={styles.marginLeftAuto}
            size={Button.Size.Small}
            buttonType={Button.Type.Text}
            onClick={() => onClickReadDocument(documentId)}
            color={ButtonColor.Secondary}
          >
            {getTranslation('common_view_document')}
          </Button>
        )}
      </div>
    </div>
  );
};
